import styled from "@emotion/native";

export const Container = styled.View({});
